import React, { Component } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { BreadCrumb } from "primereact/breadcrumb";
import { Button } from "primereact/button";
import api from "../service/ApiService";
import { Dialog } from "primereact/dialog";
import ErrorDialog from "../components/ErrorDialog";
import Loader from "../components/Loader";
import { confirmAlert } from "react-confirm-alert";
import { baseUrl } from "../service/ApiUrls";
import { OverlayPanel } from "primereact/overlaypanel";
const helpIcon = require("../assets/icons/help_icon.png");

export class DivisionManagement extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Divisions: null,
            isLoading: false,
            currentPage: 1,
            dfirst: 0,
            drows: 10,
            visible: false,
            statusDialogVisible: false, // For status popup
            rowData: null,              // Selected row for status change
        };
    }

    onDialogueHide = () => {
        this.setState({ isError: false, statusDialogVisible: false });
    };

    webcallgetDivisionList = ({ first = 0, limit = 10, filter = null } = {}) => {
        this.setState({ isLoading: true }, () => {
            api.get(baseUrl + "/division-list", {
                params: { first: first, limit: limit, filter: filter },
            })
                .then((res) => {
                    if (res.data.result.isError === false) {
                        this.setState({ ...res.data.data, isLoading: false });
                    } else {
                        this.setState({ isLoading: false });
                    }
                });
        });
    };

    // The PUT call for status change
    webcallToggleStatus = () => {
        const { rowData } = this.state;
        const updatedStatus = !rowData.isActive;

        this.setState({ statusDialogVisible: false, isLoading: true }, () => {
            api.put(`${baseUrl}/division-list/${rowData.id}/status`, {
                isActive: updatedStatus
            })
                .then((res) => {
                    this.setState({ isLoading: false });
                    if (res.data.result.isError === false) {
                        this.webcallgetDivisionList({ first: this.state.dfirst, limit: this.state.drows });
                    } else {
                        this.setState({ isError: true, errorMessage: res.data.result.errorMsg });
                    }
                })
                .catch(() => this.setState({ isLoading: false }));
        });
    };

    componentDidMount() {
        this.webcallgetDivisionList();
    }

    onPage = (event) => {
        setTimeout(() => {
            const { first, rows, page } = event;
            this.setState({
                dfirst: first,
                currentPage: page + 1,
                drows: rows,
            }, () => {
                this.webcallgetDivisionList({ first: event.page, limit: event.rows });
            });
        }, 500);
    };

    statusBodyTemplate(rowData) {
        const statusText = rowData.isActive ? "Active" : "Inactive";
        return (
            <span style={{
                padding: '0.25em 0.5em',
                borderRadius: '4px',
                color: '#fff',
                backgroundColor: rowData.isActive ? '#22C55E' : '#EF4444',
                fontWeight: 'bold',
                fontSize: '12px'
            }}>
                {statusText}
            </span>
        );
    }

    actionTemplate(rowData) {
        return (
            <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                <i
                    className="pi pi-pencil icon-p"
                    onClick={() => {
                        this.props.history.push({
                            pathname: "/new-division",
                            state: { rowData: rowData, isEdit: true },
                        });
                    }}
                    style={{ fontSize: "1.1em", color: "#000000", cursor: "pointer" }}
                ></i>
                <i
                    className={rowData.isActive ? "pi pi-times-circle" : "pi pi-check-circle"}
                    onClick={() => this.setState({ statusDialogVisible: true, rowData: rowData })}
                    style={{
                        fontSize: "1.1em",
                        color: rowData.isActive ? "#EF4444" : "#22C55E",
                        cursor: "pointer"
                    }}
                    title={rowData.isActive ? "Deactivate" : "Activate"}
                ></i>
            </div>
        );
    }

    render() {
        const items = [
            { label: "Dashboard", url: "dashboard" },
            { label: "Home Ground", url: "home-ground" },
            { label: "Division Management", url: "division-management" },
        ];

        const header = (
            <div className="row justify-content-end">
                <div className="p-col-12 p-md-4 p-lg-4">
                    <h2 style={{ textAlign: "left", paddingTop: "10px" }}>Division Management</h2>
                </div>
                <div className="p-col-12 p-md-4 p-lg-4">
                    <div id="search" className="p-inputgroup">
                        <InputText
                            placeholder="Enter Search Item"
                            onChange={(e) => this.setState({ filterData: e.target.value })}
                            onKeyDown={(e) => { if (e.keyCode === 13) this.webcallgetDivisionList({ filter: e.target.value }); }}
                        />
                        <Button
                            icon="pi pi-search"
                            className="p-button-primary s-icon s-btn"
                            onClick={() => this.webcallgetDivisionList({ filter: this.state.filterData })}
                        />
                    </div>
                </div>
                <div className="p-col-12 p-md-4 p-lg-4" style={{ textAlign: "right" }}>
                    <button
                        className="btn btn-primary"
                        onClick={() => this.props.history.push({ pathname: "/new-Division", state: { isEdit: false } })}
                    >
                        + New
                    </button>
                </div>
            </div>
        );

        // Status Confirmation Footer
        const statusFooter = (
            <div>
                <Button label="Yes" icon="pi pi-check" className="p-button-success" onClick={this.webcallToggleStatus} />
                <Button label="No" icon="pi pi-times" className="p-button-danger" onClick={() => this.setState({ statusDialogVisible: false })} />
            </div>
        );

        return (
            <div className="p-col-12 p-grid">
                <div className="p-col-12 p-lg-12 p-ll">
                    <div className="p-col-9 inline-b p-ll">
                        <BreadCrumb model={items} home={{ icon: "pi pi-home", url: "dashboard" }} />
                    </div>

                    {/* Status Toggle Dialog */}
                    <Dialog
                        header="Confirm Status Change"
                        visible={this.state.statusDialogVisible}
                        style={{ width: "30vw" }}
                        modal={true}
                        footer={statusFooter}
                        onHide={() => this.setState({ statusDialogVisible: false })}
                    >
                        <p style={{ textAlign: "center", fontWeight: "bold" }}>
                            Are you sure you want to {this.state.rowData?.isActive ? "Deactivate" : "Activate"} this Division?
                        </p>
                    </Dialog>

                    <Dialog
                        visible={this.state.isLoading}
                        modal={true}
                        closable={false}
                        showHeader={false}
                        style={{ width: "20vw" }}
                    >
                        <Loader />
                    </Dialog>

                    <div className="p-grid bg-col p-lg-12">
                        <div className="p-col">
                            <div className="datatable-paginator-demo">
                                <DataTable
                                    value={this.state.content}
                                    style={{ marginBottom: "20px" }}
                                    responsive={true}
                                    header={header}
                                    paginator
                                    totalRecords={this.state.totalRecords}
                                    onPage={this.onPage}
                                    first={this.state.dfirst}
                                    rows={this.state.drows}
                                    lazy
                                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                    rowsPerPageOptions={[10, 20, 30, 50, 100]}
                                >
                                    <Column field="name" header="Name" />
                                    <Column field="isActive" header="Is Active" body={this.statusBodyTemplate} style={{ textAlign: "center" }} />
                                    <Column field="lastModifiedBy" header="Last Modified By" style={{ textAlign: "center" }} />
                                    <Column header="Action" body={this.actionTemplate.bind(this)} style={{ textAlign: "center", width: "10%" }} />
                                </DataTable>
                            </div>
                        </div>
                    </div>

                    <Dialog visible={this.state.isError} modal style={{ width: "20vw" }} onHide={this.onDialogueHide}>
                        <ErrorDialog errorMessage={this.state.errorMessage} />
                    </Dialog>
                </div>
            </div>
        );
    }
}